import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, isProPlan }) => css`
    background: ${theme.v2.colors.neutral.highPure};
    width: 100%;
    min-height: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${isProPlan ? '16px 0' : '32px 0 16px 0'};
    border-radius: 16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: ${isProPlan ? '4px 20px 0' : '24px 20px 0'};
    }
  `}
`;

export const HeaderText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const ButtonEditor = styled.button`
  ${({ theme }) => css`
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${theme.v2.colors.brand.primaryMedium};
    border-radius: 50%;
    border: none;
    text-align: center;
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${theme.v2.font.family.primary};

    svg {
      width: 20px;
      height: 20px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 32px;
      height: 32px;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  `}
`;
